import script from "./appointmentList.vue?vue&type=script&setup=true&lang=js"
export * from "./appointmentList.vue?vue&type=script&setup=true&lang=js"

import "./appointmentList.vue?vue&type=style&index=0&id=07faecc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07faecc2"]])

export default __exports__